import { z } from '@uturn/portal/zod';

export const carrierGroupSchema = z.object({
	name: z.string().trim().min(3).max(50),
});

export type CarrierGroupFormValues = z.infer<typeof carrierGroupSchema>;
